import EntityState from '@/modules/common/store/entityState'
import MoneyMovement from '@/modules/money/movement/domain/moneyMovement'
import MoneyBoxBalance from '@/modules/money/box/domain/moneyBoxBalance'

export default class MoneyMovementState extends EntityState<MoneyMovement> {
  balances: Array<MoneyBoxBalance> = []
}
